import o from"./index.module.scss.js";const s=o;export{s as BreadcrumbsTheme};
//# sourceMappingURL=index.js.map
